<template>
  <div v-if="student" class="container my-4">
    <div class="card shadow-sm">
      <div class="card-header bg-primary text-white d-flex justify-content-between align-items-center">
        <h2 class="mb-0">
          <i class="bi bi-person-circle me-2"></i>
          {{ student.first_name }} {{ student.last_name }}
        </h2>
      </div>

      <div class="card-body">
        <div class="row">
          <!-- Profile photo -->
          <!-- Uncomment the below image when the actual photo path is available -->
          <!-- <div class="col-md-4 text-center">
            <img 
              v-if="student.student_items.length > 0 && student.student_items[0].teacher.user.profile_photo" 
              :src="`https://your-image-path/${student.student_items[0].teacher.user.profile_photo}`" 
              alt="Profile Photo" 
              class="profile-photo img-fluid rounded-circle"
            />
          </div> -->

          <div class="col-md-8">
            <p><strong><i class="bi bi-calendar-event me-2"></i>Age:</strong> {{ student.age }}</p>
            <p><strong><i class="bi bi-calendar me-2"></i>Birth Day:</strong> {{ student.birth_day }}</p>
            <p><strong><i class="bi bi-gender-ambiguous me-2"></i>Gender:</strong> {{ student.gender }}</p>
            <p><strong><i class="bi bi-phone me-2"></i>Contact:</strong> {{ student.contact }}</p>
            <p><strong><i class="bi bi-check-circle me-2"></i>Student Status:</strong> {{ student.student_status }}</p>
            <p><strong><i class="bi bi-bar-chart-line me-2"></i>Grade Level:</strong> {{ student.grade.grade_level }}</p>
            <p><strong><i class="bi bi-building me-2"></i>Institute:</strong> {{ student.institute.institute_name }}</p>
          </div>
        </div>

        <hr />

        <div class="itemClass">
          <h3><i class="bi bi-box-seam me-2"></i>Student Items</h3>

          <p><strong><i class="bi bi-list-check me-2"></i>Total Items:</strong> {{ student.student_items.length }}</p>

          <div v-for="item in paginatedItems" :key="item.id" class="mb-3">
            <p><strong><i class="bi bi-book me-2"></i>Subject:</strong> {{ item.subject.name }}</p>
            <p><strong><i class="bi bi-person-badge me-2"></i>Teacher:</strong> {{ item.teacher.user.first_name }} {{ item.teacher.user.last_name }}</p>
          </div>

          <!-- Pagination controls -->
          <nav v-if="totalPages > 1" class="mt-3">
            <ul class="pagination justify-content-center">
              <li class="page-item" :class="{ disabled: currentPage === 1 }">
                <button @click="prevPage" class="page-link">Previous</button>
              </li>
              <li class="page-item disabled">
                <span class="page-link">Page {{ currentPage }} of {{ totalPages }}</span>
              </li>
              <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                <button @click="nextPage" class="page-link">Next</button>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
  </div>

  <div v-else class="text-center">
    <p>Loading...</p>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentPage: 1, // Current page number
      itemsPerPage: 1 // Items to display per page
    };
  },
  props: {
    student: {
      type: [Object, null], // Accepts both Object and null
      // type: Object,
      default: null
    }
  },
  computed: {
    // Calculate the total number of pages
    totalPages() {
      return Math.ceil(this.student.student_items.length / this.itemsPerPage);
    },
    // Get the items for the current page
    paginatedItems() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.student.student_items.slice(start, end);
    }
  },
  methods: {
    // Go to the previous page
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },
    // Go to the next page
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    }
  }
};
</script>

<style scoped>
.profile-photo {
  max-width: 150px;
  max-height: 150px;
  border-radius: 50%;
  object-fit: cover;
}

.card {
  border-radius: 10px;
  overflow: hidden;
}

.card-header {
  font-size: 1.5rem;
  font-weight: bold;
}

.itemClass h3 {
  margin-top: 20px;
}

.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
